import { DiscoverMorePageTile, TileType } from '@varo/graphql-schema-types';
import {
  discoverMoreAdapter,
  DiscoverMoreAdapterResult,
} from 'features/discoverMore/adapters/discoverMoreAdapter';
import GetDiscoverMoreEligibleProducts from 'services/graphql/queries/GetDiscoverMoreEligibleProducts';
import { useQuery } from 'urql';

interface UseDiscoverMoreResult {
  discoverMoreData: DiscoverMoreAdapterResult;
  fetching: boolean;
  hasError: boolean;
}

const useDiscoverMore = (): UseDiscoverMoreResult => {
  const [{ data, fetching, error }] = useQuery<{
    discoverMorePage: DiscoverMorePageTile;
  }>({
    query: GetDiscoverMoreEligibleProducts,
    variables: { input: { tileType: [TileType.DiscoverMorePageTile] } },
    requestPolicy: 'cache-and-network',
  });

  const discoverMorePage = data?.discoverMorePage;
  const discoverMoreData = discoverMorePage
    ? discoverMoreAdapter(discoverMorePage)
    : { title: '', sections: [] };

  return { discoverMoreData, fetching, hasError: !!error };
};

export default useDiscoverMore;
